// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"153":"LoginbereichBlock","261":"EstateSlider","267":"ReferenceEstateSlider","293":"EstateGallery","394":"FloorPlansGallery","556":"ExpandableContent","728":"RegistrationForm","770":"EstateSliderWithText"}[chunkId] + ".css";
};